<app-dynamic-html [type]="'BrowserCompatibility'"></app-dynamic-html>